import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Service extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'service',
            id: this.props.Id,
            data:null,
            loading: true,
            lockScreen: 0,
            parents: [],
            record: {
                id: 0,
                title: '',
                parentId: null,
                isActive: true,
                description: ''
            }
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({ record: data.record, parents: data.parents, loading: false, data:data });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    handleChange(field, value) {
        const record = { ...this.state.record };
        record[field] = value;
        this.setState({ record });
    }

    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });
        this.httpPost(`api/v1/${this.state.controllerName}/save`, this.state.record)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('سرویس با موفقیت ذخیره شد');
                    this.setState({ redirect: '/services' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    renderForm() {
        const { record, parents } = this.state;
        const isEdit = record.id > 0;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">{isEdit ? `ویرایش سرویس: ${record.title}` : 'افزودن سرویس جدید'}</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/services/" className="btn btn-dim btn-outline-light"><em className="icon ni ni-arrow-left"></em><span>بازگشت</span></NavLink>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered">
                        <div className="card-inner">
                            <form onSubmit={e => this.save(e)}>
                                <div className="row g-4">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">عنوان <span className="text-danger">*</span></label>
                                            <input type="text" className="form-control" value={record.title} onChange={e => this.handleChange('title', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">والد</label>
                                            <select className="form-select" value={record.parentId || ''} onChange={e => this.handleChange('parentId', e.target.value ? parseInt(e.target.value) : null)}>
                                                <option value="">بدون والد</option>
                                                {parents.map(p => <option key={p.id} value={p.id}>{p.title}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <label className="form-label">وضعیت</label>
                                            <select className="form-select" value={record.isActive ? '1' : '0'} onChange={e => this.handleChange('isActive', e.target.value === '1')}>
                                                <option value="1">فعال</option>
                                                <option value="0">غیرفعال</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className="form-label">توضیحات</label>
                                            <textarea className="form-control" rows="3" value={record.description} onChange={e => this.handleChange('description', e.target.value)}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                            {this.state.lockScreen === 1 && <span className="spinner-border spinner-border-sm mr-2"></span>}
                                            <em className="icon ni ni-save"></em> ذخیره
                                        </button>
                                        <NavLink to="/services/" className="btn btn-dim btn-outline-light ms-2"><em className="icon ni ni-cross"></em> انصراف</NavLink>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={{ global: this.state.data?.global }} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}